import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

// Sweet Alert Component Styles
import '@core/scss/vue/libs/vue-sweetalert.scss'

Vue.use(VueSweetalert2)
